import { BehaviorSubject, Observable } from 'rxjs';

export class DataSharingService {
    private result: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
    public result$: Observable<any[]> = this.result.asObservable();

    updateResultList(updatedVal) {
        this.result.next(updatedVal);
    }

} 